import { EnrollmentConnectionStatusEnum } from './enrollmentUtils';

export const connectionStatusFormOptions = [
  {
    value: EnrollmentConnectionStatusEnum.CONNECTED,
    label: `enrollment.connection.status.${EnrollmentConnectionStatusEnum.CONNECTED}`,
  },
  {
    value: EnrollmentConnectionStatusEnum.PENDING,
    label: `enrollment.connection.status.${EnrollmentConnectionStatusEnum.PENDING}`,
  },
  {
    value: EnrollmentConnectionStatusEnum.NONE,
    label: `enrollment.connection.status.${EnrollmentConnectionStatusEnum.NONE}`,
  },
];



// WEBPACK FOOTER //
// ./src/common/formOptions.js